/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

export default function Capabilities({ data }) {
  return (
    <section className="container mx-auto px-4 lg:px-8 py-16 relative z-10">
      <div className="text-center mb-12">
        <span className="section-eyebrow">Capabilities</span>
        <h2 className="text-4xl lg:text-5xl font-bold text-white mt-4">
          Engineering across <span className="neon-text">all technologies</span>
        </h2>
      </div>

      <div className="max-w-6xl mx-auto">
        {data.map((item) => {
          const reverse = item.align === 'left';
          return (
            <div
              key={item.title}
              className={`capability-block ${reverse ? 'is-reverse' : ''}`}
            >
              <div className="capability-image">
                <img src={item.imageUrl} alt={item.title} />
              </div>
              <div>
                <h3 className="capability-title">{item.title}</h3>
                <p className="capability-desc">{item.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
